<template>
  <el-dialog
    title="Create Email Channel"
    width="40%"
    :visible.sync="showDialog"
    append-to-body>

    <div class="dialog-body">
      <el-form :model="emailChannelForm" ref="emailChannelForm">
        <el-form-item prop="email" label="Email" :rules="emailInputRules">
          <el-input :autofocus="true" v-model="emailChannelForm.email" />
        </el-form-item>
      </el-form>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="showDialog = false" plain>Cancel</el-button>
      <el-button 
        type="primary" 
        :disabled="addingEmailChannel"
        @click="handleSaveChannel" 
        plain
      >
        Save
        <i v-if="addingEmailChannel" class="fa fa-spinner fa-pulse"></i>
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex';
import { channelTypes } from '@/constants';

export default {
  name: 'EmailChannelCreateDialog',

  data: () => ({
    emailChannelForm: {
      email: '',
    },
    emailInputRules: [
      { type: 'email', message: 'Please provide a valid email address.', trigger: 'blur' },
      { required: true, message: 'Email Address is required', trigger: 'blur' },
    ],
  }),

  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    ...mapState('channel', ['addingEmailChannel']),

    showDialog: {
      get() {
        return this.isVisible;
      },

      set(visibility) {
        this.$emit('onVisibleChanged', visibility);
      },
    },
  },

  methods: {
    handleSaveChannel() {
      this.$refs.emailChannelForm.validate(valid => {
        if (valid) return this.addEmailChannel();
        return false;
      });
    },

    addEmailChannel() {
      const emailChannel = {
        handle: this.emailChannelForm.email,
        channel_type: channelTypes.MMS_EMAIL,
        live: true,
        extra_data: '',
      };

      this.$store.dispatch('channel/addEmailChannel', emailChannel).then(() => {
        this.$emit('onEmailChannelAdded');
        this.showDialog = false;
      });
    },
  },

  watch: {
    showDialog() {
      if (this.$refs && this.$refs.emailChannelForm) {
        this.$refs.emailChannelForm.resetFields();
      }
    },
  },
};
</script>




// WEBPACK FOOTER //
// EmailChannelCreateDialog.vue?5469b9f1